import React from "react";
import "./Services.css";
import icon1 from "../../../images/services/icon/social.webp";
import icon2 from "../../../images/services/icon/seo.webp";
import icon3 from "../../../images/services/icon/advanced.webp";
import icon4 from "../../../images/services/icon/email.webp";
import icon5 from "../../../images/services/icon/pay.webp";
import icon6 from "../../../images/services/icon/content.webp";
import Service from "./Service";

const servicesData = [
  {
    id: 1,
    name: "SOCIAL MEDIA MARKETING",
    description: "Customers are interacting with brands through social media. SMM can bring remarkable success to your business.",
    icon: icon1,
  },
  {
    id: 2,
    name: "SEO OPTIMIZATION",
    description: "Search Engine Optimization is fundamental. Our SEO strategies can grant you a high-ranking placement in search results.",
    icon: icon2,
  },
  {
    id: 3,
    name: "ADVANCED ANALYTICS",
    description: "Our services cover all aspects of web analytics, from initial setup to advanced tracking solutions and custom features.",
    icon: icon3,
  },
  {
    id: 4,
    name: "EMAIL MARKETING",
    description: "Our custom Email Marketing services can help you save time and money",
    icon: icon4,
  },
  {
    id: 5,
    name: "PAY PER CLICK",
    description: "Pay-Per-Click marketing is easy and cost-effective. We know everything about PPC!",
    icon: icon5,
  },
  {
    id: 6,
    name: "CONTENT STARTEGY",
    description: "Engage with your audience through great, original content.",
    icon: icon6,
  },
];

function Services() {
  return (
    <div className="service-container">
      <div className="text-center pt-5 w-50 m-auto">
        <h4 style={{ fontWeight: "300", marginBottom: "10px" }}>
        We use strategy and experience to generate results
        </h4>
        <h2 style={{ fontSize: "" }}>OUR STRATEGY</h2>
      </div>

      <div className="row service">
        {servicesData.map((data) => (
          <Service data={data} key={data.id}></Service>
        ))}
      </div>
    </div>
  );
}

export default Services;
